module.exports = __webpack_public_path__ + "img/icon-14.ab884112.png";